import { ofType } from "redux-observable";
import { from, of } from "rxjs";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { getAuthorizedEntities } from "../../actions/lp";
import { GET_AUTHORIZED_ENTITIES_FAILURE, GET_AUTHORIZED_ENTITIES_REQUEST } from "../../actions/lp/actionTypes";
import { addNotification } from "../../actions/ui";
import { DEFAULT_NOTIFICATION_CLOSE_TIMEOUT, NotificationTypeEnum } from "../../actions/ui/types";
export var getAuthorizedEntitiesEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe(ofType(GET_AUTHORIZED_ENTITIES_REQUEST), switchMap(function(action) {
        var _action_payload = action.payload, entityFilter = _action_payload.entityFilter, logisticsPartyId = _action_payload.logisticsPartyId;
        return from(api.clwsServices.getAuthorizedEntitiesService({
            entityFilter: entityFilter,
            logisticsPartyId: logisticsPartyId
        }).pipe(mergeMap(function(param) {
            var permissionToEntitiesMap = param.permissionToEntitiesMap;
            return of(getAuthorizedEntities.success({
                permissionToEntitiesMap: permissionToEntitiesMap
            }));
        }), catchError(function(err) {
            return of(getAuthorizedEntities.failure(err), addNotification({
                type: NotificationTypeEnum.ERROR,
                action: GET_AUTHORIZED_ENTITIES_FAILURE,
                message: "lps.get_authorized_entities.failure",
                timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT
            }));
        })));
    }));
};
export default getAuthorizedEntitiesEpic;

//# sourceMappingURL=getAuthhorizedEntitiesEpic.js.map